<script lang="ts">
    import Icon from "@components/material/Icon.svelte"
    import type { HelpDocPaths } from "virtual:documentation"
    import { openHelp } from "./Help.module"
    import { createEventDispatcher } from "svelte"
    export let path: HelpDocPaths
    const dispatch = createEventDispatcher()
</script>

<button
    type="button"
    class="help-path"
    aria-label="open help"
    on:click|preventDefault={() => dispatch("opened") && openHelp(path)}
>
    <Icon icon="help-solid" />
</button>

<style>
    .help-path {
        appearance: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 0.95em;
        height: 0.95em;
        margin-left: 0.25em;
        border: 0;
        background: transparent;
        color: var(--darkpurple--);
        cursor: pointer;
        font: inherit;
        line-height: 1;
        opacity: 0.6;
        padding: 0;
        vertical-align: -0.08em;
    }

    .help-path :global(svg) {
        width: 100%;
        height: 100%;
    }
</style>
